import React from 'react';
// import { Divider } from 'semantic-ui-react'

const RtesMovDi1 = ({styles, handleClickRegr, handleClickSel1, handleClickSel2, handleClickSel3}) => {
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      
      {/* <Divider inverted />

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large dollar sign violet icon"></i>
        Relación de pagos
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large dollar sign violet icon"></i>
        Pago detallado
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large dollar sign violet icon"></i>
        Totales
      </button> */}
    </div>
  )
};

export default RtesMovDi1
